module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Pegawai")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/pegawai"
    }
  }, [_vm._v("Master Data")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding-left": "20px",
      "padding-top": "10px"
    }
  }, [_c('h4', [_c('b', [_vm._v("MASTER DATA")])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding-right": "20px",
      "padding-top": "10px"
    }
  }, [(_vm.level.indexOf('ADMIN TOKO') !== -1 || _vm.level.indexOf('ROOT') !== -1) ? _c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.addData()
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.tableData1,
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "#",
      "header-align": "center",
      "align": "center",
      "width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                            " + _vm._s(scope.row.no) + ".\n                          ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "NAMA",
      "prop": "nama",
      "header-align": "left",
      "align": "left",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Nama"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariNama()
            }
          },
          model: {
            value: (_vm.cari_nama),
            callback: function($$v) {
              _vm.cari_nama = $$v
            },
            expression: "cari_nama"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.nama))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "NIK",
      "prop": "nik",
      "header-align": "left",
      "align": "left",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter NIK"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariNik()
            }
          },
          model: {
            value: (_vm.cari_nik),
            callback: function($$v) {
              _vm.cari_nik = $$v
            },
            expression: "cari_nik"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.nik))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "HP",
      "prop": "hp",
      "header-align": "left",
      "align": "left",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                            " + _vm._s(scope.row.hp) + "\n                          ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "LEVEL",
      "prop": "level",
      "header-align": "left",
      "align": "left",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Level"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariLevel()
            }
          },
          model: {
            value: (_vm.cari_level),
            callback: function($$v) {
              _vm.cari_level = $$v
            },
            expression: "cari_level"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.level))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "TOKO",
      "prop": "toko",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Toko"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariToko()
            }
          },
          model: {
            value: (_vm.cari_toko),
            callback: function($$v) {
              _vm.cari_toko = $$v
            },
            expression: "cari_toko"
          }
        })] : _c('span', [_c('a', {
          staticStyle: {
            "width": "100%",
            "height": "100%"
          },
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.gantiToko(scope.row.kode, scope.row.nama)
            }
          }
        }, [_vm._v(_vm._s(scope.row.toko))])])]
      }
    }])
  }), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1 || _vm.level.indexOf('ROOT') !== -1) ? _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "PILIHAN",
      "align": "center",
      "header-align": "center",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit1) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Ok",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-check"
          },
          on: {
            "click": function($event) {
              _vm.confirmEdit1(scope.$index, scope.row, ('form' + scope.$index))
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (!scope.row.edit) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Edit",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.confirmEdit(scope.$index, scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (!scope.row.edit) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Reset Password",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small",
            "icon": "el-icon-refresh"
          },
          on: {
            "click": function($event) {
              return _vm.confirmOpen(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.edit1) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Cancel",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "el-icon-error",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.cancelEdit(scope.$index, scope.row)
            }
          }
        })], 1) : _vm._e()]
      }
    }], null, false, 3794012943)
  }) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.tableData.length,
      "page-size": _vm.page_size,
      "current-page": _vm.current_page
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdd),
      expression: "loadingModalAdd"
    }],
    attrs: {
      "title": "Tambah Data",
      "visible": _vm.dialogFormVisible,
      "width": "500px",
      "top": "2%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "NIK",
      "prop": "nik"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.nik),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nik", $$v)
      },
      expression: "row1.nik"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nama",
      "prop": "nama"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.nama),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nama", $$v)
      },
      expression: "row1.nama"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "HP",
      "prop": "hp"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.hp),
      callback: function($$v) {
        _vm.$set(_vm.row1, "hp", $$v)
      },
      expression: "row1.hp"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Level",
      "prop": "kode_pegawai_level"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Pilih Level"
    },
    model: {
      value: (_vm.row1.kode_pegawai_level),
      callback: function($$v) {
        _vm.$set(_vm.row1, "kode_pegawai_level", $$v)
      },
      expression: "row1.kode_pegawai_level"
    }
  }, _vm._l((_vm.region), function(item) {
    return _c('el-option', {
      key: item.kode,
      attrs: {
        "label": item.nama,
        "value": item.kode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank",
      "prop": "kode_bank"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Pilih Bank"
    },
    model: {
      value: (_vm.row1.kode_bank),
      callback: function($$v) {
        _vm.$set(_vm.row1, "kode_bank", $$v)
      },
      expression: "row1.kode_bank"
    }
  }, _vm._l((_vm.bank), function(item) {
    return _c('el-option', {
      key: item.kode,
      attrs: {
        "label": item.nama,
        "value": item.kode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Rekening",
      "prop": "rekening"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmEdit1(0, _vm.row1, 'formAdd')
      }
    },
    model: {
      value: (_vm.row1.rekening),
      callback: function($$v) {
        _vm.$set(_vm.row1, "rekening", $$v)
      },
      expression: "row1.rekening"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1 || _vm.level.indexOf('ROOT') !== -1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalEdit),
      expression: "loadingModalEdit"
    }],
    attrs: {
      "title": "Edit Data",
      "visible": _vm.dialogFormEdit,
      "width": "500px",
      "top": "2%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "formEdit",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "NIK",
      "prop": "nik"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.nik),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nik", $$v)
      },
      expression: "row1.nik"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nama",
      "prop": "nama"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.nama),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nama", $$v)
      },
      expression: "row1.nama"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "HP",
      "prop": "hp"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.hp),
      callback: function($$v) {
        _vm.$set(_vm.row1, "hp", $$v)
      },
      expression: "row1.hp"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Level",
      "prop": "kode_pegawai_level"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Pilih Level"
    },
    model: {
      value: (_vm.row1.kode_pegawai_level),
      callback: function($$v) {
        _vm.$set(_vm.row1, "kode_pegawai_level", $$v)
      },
      expression: "row1.kode_pegawai_level"
    }
  }, _vm._l((_vm.region), function(item) {
    return _c('el-option', {
      key: item.kode,
      attrs: {
        "label": item.nama,
        "value": item.kode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Aktif",
      "prop": "aktif"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Pilih Aktif"
    },
    model: {
      value: (_vm.row1.aktif),
      callback: function($$v) {
        _vm.$set(_vm.row1, "aktif", $$v)
      },
      expression: "row1.aktif"
    }
  }, _vm._l((_vm.aktif), function(item) {
    return _c('el-option', {
      key: item.kode,
      attrs: {
        "label": item.nama,
        "value": item.kode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank",
      "prop": "kode_bank"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Pilih Bank"
    },
    model: {
      value: (_vm.row1.kode_bank),
      callback: function($$v) {
        _vm.$set(_vm.row1, "kode_bank", $$v)
      },
      expression: "row1.kode_bank"
    }
  }, _vm._l((_vm.bank), function(item) {
    return _c('el-option', {
      key: item.kode,
      attrs: {
        "label": item.nama,
        "value": item.kode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Rekening",
      "prop": "rekening"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmEdit1(0, _vm.row1, 'formEdit')
      }
    },
    model: {
      value: (_vm.row1.rekening),
      callback: function($$v) {
        _vm.$set(_vm.row1, "rekening", $$v)
      },
      expression: "row1.rekening"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormEdit = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1(0, _vm.row1, 'formEdit')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDel),
      expression: "loadingModalDel"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormWilDel,
      "width": "500px",
      "top": "2%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormWilDel = $event
      }
    }
  }, [_c('h4', [_vm._v("Apakah Anda yakin akan menghapus Pegawai " + _vm._s(_vm.nama) + "?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormWilDel = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDel1()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Informasi",
      "visible": _vm.dialogFormInfo,
      "width": "500px",
      "top": "2%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormInfo = $event
      }
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormInfo = false
      }
    }
  }, [_vm._v("OK")])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalOpen),
      expression: "loadingModalOpen"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormOpen,
      "width": "600px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormOpen = $event
      }
    }
  }, [_c('h4', [_vm._v("Apakah Anda yakin akan melakukan reset password  "), _c('b', [_vm._v(_vm._s(_vm.nama))]), _vm._v(" ?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormOpen = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmOpen1()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalGantiToko),
      expression: "loadingModalGantiToko"
    }],
    attrs: {
      "title": this.keterangan,
      "visible": _vm.dialogGantiToko,
      "width": "500px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogGantiToko = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Cari Toko"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.handleSelect.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.cari_toko),
      callback: function($$v) {
        _vm.cari_toko = $$v
      },
      expression: "cari_toko"
    }
  }), _vm._v(" \n              "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.toko,
      "highlight-current-row": "",
      "responsive": ""
    },
    on: {
      "current-change": _vm.handleCurrentChangeToko
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "#",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.$index + 1) + "\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "Toko",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.nama) + "\n                  ")]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogGantiToko = false
      }
    }
  }, [_vm._v("Tutup")]), _vm._v(" "), (_vm.level.indexOf('ADMIN') !== -1 || _vm.level.indexOf('ROOT') !== -1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.simpanTokoBaru()
      }
    }
  }, [_vm._v("Simpan")]) : _vm._e()], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-81e1198c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/master_data/Pegawai1.vue
// module id = 1422
// module chunks = 2